import { useEffect } from 'react';
import { redirectToLogin } from '../utils/token-storage';

/**
 * Login Page — LANGSUNG redirect ke Portal SSO (STANDAR pattern).
 * Tidak ada UI login di sini — Portal yang handle UI login.
 * STANDAR: pakai utils/token-storage.ts → redirectToLogin(returnTo).
 */
export function LoginPage() {
  useEffect(() => {
    // STANDAR: redirect ke Portal dengan return_to=<pathname>
    redirectToLogin('/');
  }, []);

  return (
    <div style={{
      display: 'grid',
      placeItems: 'center',
      height: '100vh',
      background: '#0f172a',
      color: '#94a3b8',
    }}>
      Mengalihkan ke Indopoin SSO…
    </div>
  );
}